// Define cell data type
const CELL_DATA_TYPES = {
  TEXT: 'text',
  UCWORDS: 'ucwords',
  EMAIL: 'email',
  NUMBER: 'number',
  DATE: 'date',
  DATETIME: 'datetime',
  TIMESTAMP: 'timestamp',
  DURATION: 'duration',
  STATUS: 'status',
  SWITCH: 'switch',
  PLATFORM: 'platform',
  MONEY: 'money',
  PERCENTAGE: 'percent',
  BOOL: 'boolean',
  CODE: 'code',
  PREVIEW: 'preview',
  RECORDED_PREVIEW: 'recordedPreview',
  IMAGE: 'image',
  PROGRESS: 'progress',
  PROFILE: 'profile',
  ROLE: 'role',
  SUB_LIST: 'subList',
  EVENT_TIMESTAMP: 'eventTimestamp',
  REQUEST: 'request',
  QUIZ_RESULT_PERCENT_PF: 'quizResultPercentPF',
  QUIZ_RESULT_MARKS_OUT_OF: 'quizResultMarksOutOf',
  QUIZ_ATTEMPT: 'quizAttempt',
  QUIZ_ANSWER: 'quizAnswer',
  LONG_DESCRIPTION: 'longDescription',
  BIO: 'bio',
  CURRENT_DATA_NAME: 'currentDataName',
};

export default CELL_DATA_TYPES;
